module.exports = __webpack_public_path__ + "img/dialogue.af04619a.svg";